module.exports = __webpack_public_path__ + "img/locationMap3.4d26b9fd.png";